export const upperFirstLetter = (word) => word.charAt(0).toUpperCase() + word.slice(1)
// eslint-disable-next-line import/no-anonymous-default-export
export default {
    upperFirstLetter
}